const UserRoles = {
	invited: 0,
	participant: 1,
	superadmin: 2,
};
export default UserRoles;
